import { IType } from './implement';
import { t } from 'helpers/i18n';
import { IMap } from 'interfaces';

export type ITypeWithColor = IMap<{
  value: number;
  label: string;
  color: string;
}>;

const EContractSposType = {
  MerRegisterSerFirstTime: 1,
  OpenNewShop: 2,
  AddTidInOldShop: 3,
};

const CONTRACT_SPOS_TYPE: IType = {
  [EContractSposType.MerRegisterSerFirstTime]: {
    value: EContractSposType.MerRegisterSerFirstTime,
    label: t('Spos.MerRegisterSerFirstTime'),
  },
  [EContractSposType.OpenNewShop]: {
    value: EContractSposType.OpenNewShop,
    label: t('Spos.OpenNewShop'),
  },
  [EContractSposType.AddTidInOldShop]: {
    value: EContractSposType.AddTidInOldShop,
    label: t('Spos.AddTidInOldShop'),
  },
};

const EAppraisalStatus = {
  WaitingToReceive: 0,
  Appraising: 1,
  WaitingForApprove: 2,
  AddProfile: 3,
  AppraisalApprovedWaitingForConfigDevices: 4,
  AppraisalApprovedWaitingForImplement: 5,
  SuccessfulProfileImplement: 6,
  ProfileDeploymentFailed: 7,
  CloseRequest: 8,
  Processing: 9,
  AppraisalApprovedWaitingForUpdateDevices: 10,
};

const APPRAISAL_STATUS: ITypeWithColor = {
  [EAppraisalStatus.WaitingToReceive]: {
    value: EAppraisalStatus.WaitingToReceive,
    label: t('Spos.WaitingToReceive'),
    color: '#0674e8',
  },
  [EAppraisalStatus.Appraising]: {
    value: EAppraisalStatus.Appraising,
    label: t('Spos.Appraising'),
    color: '#937DC2',
  },
  [EAppraisalStatus.WaitingForApprove]: {
    value: EAppraisalStatus.WaitingForApprove,
    label: t('Spos.WaitingForApprove'),
    color: '#f78212',
  },
  [EAppraisalStatus.AddProfile]: {
    value: EAppraisalStatus.AddProfile,
    label: t('Spos.AddProfile'),
    color: '#f78212',
  },
  [EAppraisalStatus.AppraisalApprovedWaitingForConfigDevices]: {
    value: EAppraisalStatus.AppraisalApprovedWaitingForConfigDevices,
    label: t('Spos.AppraisalApprovedWaitingForConfigDevices'),
    color: '#f6c005',
  },
  [EAppraisalStatus.AppraisalApprovedWaitingForImplement]: {
    value: EAppraisalStatus.AppraisalApprovedWaitingForImplement,
    label: t('Spos.AppraisalApprovedWaitingForImplement'),
    color: '#11b8b8',
  },
  [EAppraisalStatus.SuccessfulProfileImplement]: {
    value: EAppraisalStatus.SuccessfulProfileImplement,
    label: t('Spos.SuccessfulProfileImplement'),
    color: '#53c305',
  },
  [EAppraisalStatus.ProfileDeploymentFailed]: {
    value: EAppraisalStatus.ProfileDeploymentFailed,
    label: t('Spos.ProfileDeploymentFailed'),
    color: '#5C2E7E',
  },
  [EAppraisalStatus.CloseRequest]: {
    value: EAppraisalStatus.CloseRequest,
    label: t('Spos.CloseRequest'),
    color: '#FF1E1E',
  },
  [EAppraisalStatus.Processing]: {
    value: EAppraisalStatus.Processing,
    label: t('Spos.Processing'),
    color: '#737068',
  },
  [EAppraisalStatus.AppraisalApprovedWaitingForUpdateDevices]: {
    value: EAppraisalStatus.AppraisalApprovedWaitingForUpdateDevices,
    label: t('Spos.AppraisalApprovedWaitingForUpdateDevices'),
    color: '#f542f5',
  },
};

const ESposMidTidBankStatus = {
  WaitForTheGrant: 1,
  Granted: 2,
};

const SPOS_MID_TID_BANK_STATUS: ITypeWithColor = {
  [ESposMidTidBankStatus.WaitForTheGrant]: {
    value: ESposMidTidBankStatus.WaitForTheGrant,
    label: t('Spos.WaitForTheGrant'),
    color: '#FFB200',
  },
  [ESposMidTidBankStatus.Granted]: {
    value: ESposMidTidBankStatus.Granted,
    label: t('Spos.Granted'),
    color: '#53c305',
  },
};

const EStatusExportMidTidBank = {
  All: 1,
  ContractDontRequestMidTid: 2,
};

const STATUS_EXPORT_MID_TID_BANK = {
  [EStatusExportMidTidBank.All]: {
    value: EStatusExportMidTidBank.All,
    label: t('Spos.AllStatusMidTidBank'),
  },
  [EStatusExportMidTidBank.ContractDontRequestMidTid]: {
    value: EStatusExportMidTidBank.ContractDontRequestMidTid,
    label: t('Spos.ContractDontRequestMidTid'),
  },
};

const ESposContractType = {
  PurchaseOutrightDevice: 1,
  RentDevice: 3,
};

const SPOS_CONTRACT_TYPE_DEVICE = {
  [ESposContractType.PurchaseOutrightDevice]: {
    value: ESposContractType.PurchaseOutrightDevice,
    label: t('SposContract.BuyOut'),
  },
  [ESposContractType.RentDevice]: {
    value: ESposContractType.RentDevice,
    label: t('SposContract.Leaseback'),
  },
};

const PROVIDER_MAPPING: { [key: string]: any } = {
  '2101': 'Nam A Bank',
  '0241': 'VNNG',
};

const EProviderType = {
  NAB: '2101',
  VNNG: '0241',
};

const PROVIDER_TYPE = {
  [EProviderType.NAB]: {
    value: EProviderType.NAB,
    label: t('Spos.NAB'),
  },
  [EProviderType.VNNG]: {
    value: EProviderType.VNNG,
    label: t('Spos.VNNG'),
  },
};

const EDisplayOptions = {
  MerchantCode: t('MerchantCode'),
  Provider: t('Spos.Provider'),
  Address: t('Address'),
  ContractType: t('Spos.ContractType'),
  SaleInformation: t('Spos.SaleInformation'),
  SubmissionDate: t('Spos.SubmissionDate'),
  ApprovalDate: t('Spos.ApprovalDate'),
  Appraiser: t('Spos.Appraiser'),
  SposContractType: t('Spos.SposContractType'),
  ListOfDoc: t('Spos.ListOfDoc'),
  ProfileStatus: t('Spos.ProfileStatus'),
  Note: t('Note'),
  CreatedAt: t('Spos.CreatedAt'),
  UpdateAt: t('Spos.UpdatedAt'),
  NumberOfDevice: t('NumberOfDevice'),
  NoteAppraised: t('Spos.NoteAppraised'),
  NoteApproved: t('Spos.NoteApproved'),
  SposId: t('Spos.Id'),
  TaxCode: t('Spos.TaxCode'),
  CreatedBy: t('SposContract.CreatedBy'),
  Department: t('Department'),
  DepartmentId: t('DepartmentId'),
  ReviewTime: t('Spos.ReviewTime'),
  ImplementationTime: t('Spos.ImplementationTime'),
  NumberOfTimeAddProfile: t('Spos.NumberOfTimeAddProfile'),
  ReasonForRefusal: t('ReasonForRefusal'),
};

const SPOS_DISPLAY_OPTIONS: {
  [key: string]: { value: string; isChecked: boolean };
} = {
  [EDisplayOptions.MerchantCode]: {
    value: EDisplayOptions.MerchantCode,
    isChecked: true,
  },
  [EDisplayOptions.Provider]: {
    value: EDisplayOptions.Provider,
    isChecked: true,
  },
  [EDisplayOptions.Address]: {
    value: EDisplayOptions.Address,
    isChecked: true,
  },
  [EDisplayOptions.ContractType]: {
    value: EDisplayOptions.ContractType,
    isChecked: true,
  },
  [EDisplayOptions.SaleInformation]: {
    value: EDisplayOptions.SaleInformation,
    isChecked: true,
  },
  [EDisplayOptions.SubmissionDate]: {
    value: EDisplayOptions.SubmissionDate,
    isChecked: true,
  },
  [EDisplayOptions.ApprovalDate]: {
    value: EDisplayOptions.ApprovalDate,
    isChecked: false,
  },
  [EDisplayOptions.Appraiser]: {
    value: EDisplayOptions.Appraiser,
    isChecked: true,
  },
  [EDisplayOptions.SposContractType]: {
    value: EDisplayOptions.SposContractType,
    isChecked: true,
  },
  [EDisplayOptions.ListOfDoc]: {
    value: EDisplayOptions.ListOfDoc,
    isChecked: true,
  },
  [EDisplayOptions.ProfileStatus]: {
    value: EDisplayOptions.ProfileStatus,
    isChecked: false,
  },
  [EDisplayOptions.Note]: {
    value: EDisplayOptions.Note,
    isChecked: false,
  },
  [EDisplayOptions.CreatedAt]: {
    value: EDisplayOptions.CreatedAt,
    isChecked: true,
  },
  [EDisplayOptions.UpdateAt]: {
    value: EDisplayOptions.UpdateAt,
    isChecked: false,
  },
  [EDisplayOptions.NumberOfDevice]: {
    value: EDisplayOptions.NumberOfDevice,
    isChecked: true,
  },
  [EDisplayOptions.NoteAppraised]: {
    value: EDisplayOptions.NoteAppraised,
    isChecked: false,
  },
  [EDisplayOptions.NoteApproved]: {
    value: EDisplayOptions.NoteApproved,
    isChecked: false,
  },
};

const SPOS_DISPLAY_OPTIONS_PARTNER: {
  [key: string]: { value: string; isChecked: boolean };
} = {
  [EDisplayOptions.SposId]: {
    value: EDisplayOptions.SposId,
    isChecked: false,
  },
  [EDisplayOptions.MerchantCode]: {
    value: EDisplayOptions.MerchantCode,
    isChecked: true,
  },
  [EDisplayOptions.TaxCode]: {
    value: EDisplayOptions.TaxCode,
    isChecked: true,
  },
  [EDisplayOptions.SposContractType]: {
    value: EDisplayOptions.SposContractType,
    isChecked: true,
  },
  [EDisplayOptions.NumberOfDevice]: {
    value: EDisplayOptions.NumberOfDevice,
    isChecked: true,
  },
  [EDisplayOptions.CreatedBy]: {
    value: EDisplayOptions.CreatedBy,
    isChecked: true,
  },
  [EDisplayOptions.Department]: {
    value: EDisplayOptions.Department,
    isChecked: false,
  },
  [EDisplayOptions.DepartmentId]: {
    value: EDisplayOptions.DepartmentId,
    isChecked: false,
  },
  [EDisplayOptions.SubmissionDate]: {
    value: EDisplayOptions.SubmissionDate,
    isChecked: true,
  },
  [EDisplayOptions.ReviewTime]: {
    value: EDisplayOptions.ReviewTime,
    isChecked: false,
  },
  [EDisplayOptions.ImplementationTime]: {
    value: EDisplayOptions.ImplementationTime,
    isChecked: false,
  },
  [EDisplayOptions.ProfileStatus]: {
    value: EDisplayOptions.ProfileStatus,
    isChecked: true,
  },
  [EDisplayOptions.NumberOfTimeAddProfile]: {
    value: EDisplayOptions.NumberOfTimeAddProfile,
    isChecked: false,
  },
  [EDisplayOptions.Note]: {
    value: EDisplayOptions.Note,
    isChecked: true,
  },
  [EDisplayOptions.ReasonForRefusal]: {
    value: EDisplayOptions.ReasonForRefusal,
    isChecked: false,
  },
};

export default {
  CONTRACT_SPOS_TYPE,
  APPRAISAL_STATUS,
  SPOS_MID_TID_BANK_STATUS,
  MAX_MONTH_RANGE_CREATE_DATE: 3,
  EAppraisalStatus,
  STATUS_EXPORT_MID_TID_BANK,
  EStatusExportMidTidBank,
  MAX_DAY_RANGE_EXPORT_MID_TID_BANK: 31,
  MAX_PREVIOUS_DAY: 1825,
  EContractSposType,
  SPOS_CONTRACT_TYPE_DEVICE,
  PROVIDER_MAPPING,
  PROVIDER_TYPE,
  SPOS_DISPLAY_OPTIONS,
  EProviderType,
  SPOS_DISPLAY_OPTIONS_PARTNER,
  EDisplayOptions,
};
